import { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';

export const useTracking = (country, period = 'today') => {
  const [stats, setStats] = useState(null);
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);

  const load = useCallback(async () => {
    try {
      const [statsData, eventsData] = await Promise.all([
        api.getOperationalStats(country, period),
        api.getOperational(country, 'tracking')
      ]);
      setStats(statsData);
      setCategories(statsData.categories || []);
      setEvents((eventsData.items || []).sort((a, b) => b.timestamp - a.timestamp));
    } catch (error) {
      console.error('Error loading tracking data:', error);
    }
  }, [country, period]);

  useEffect(() => {
    load();
  }, [load]);

  const refresh = () => load();

  return { stats, events, categories, refresh };
};
